import styled from 'styled-components';

export const AccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
`;

export const AccessCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 3rem;
  padding-top: 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 100%;
  text-align: center;

  @media (max-width: 768px) {
    padding: 2rem;
    margin: 1rem;
  }
`;

export const Title = styled.h1`
  color: #234e9d;
  font-size: 2rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Message = styled.p`
  color: #555;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  margin-bottom: 1rem;
  transition: border-color 0.3s ease;
  text-align: center;
  font-weight: 500;
  letter-spacing: 1px;

  &:focus {
    outline: none;
    border-color: #234e9d;
  }

  &::placeholder {
    color: #999;
    letter-spacing: normal;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #234e9d, #1a3a75);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(35, 78, 157, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.p`
  color: #d32f2f;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const SuccessMessage = styled.p`
  color: #388e3c;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const InfoBox = styled.div`
  background: rgba(35, 78, 157, 0.1);
  border-left: 4px solid #234e9d;
  padding: 1rem;
  margin-top: 2rem;
  border-radius: 5px;
  text-align: left;
`;

export const InfoText = styled.p`
  color: #234e9d;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
`;

export const SecondarySection = styled.div`
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 1.25rem;
  margin-top: 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 500px;

  @media (max-width: 768px) {
    padding: 1rem;
    margin-top: 1.5rem;
  }
`;

export const SecondaryText = styled.p`
  color: #333;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 1.25rem;
  white-space: pre-wrap;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  max-width: 500px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  margin-top: 1rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
  }

  &:focus {
    outline: 2px solid #234e9d;
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    width: 100%;
    max-width: 500px;
    height: auto;
    border-radius: 8px;
  }
`;